/**
 * Replace common black stroke/fill colors in SVG text with the given color.
 */
export function colorizeSvg(svgText: string, color: string): string {
  return svgText
    .replace(/stroke:#000000/g, `stroke:${color}`)
    .replace(/stroke:#1a1a1a/g, `stroke:${color}`)
    .replace(/fill:#000000/g, `fill:${color}`)
    .replace(/fill:#1a1a1a/g, `fill:${color}`)
    .replace(/stroke="black"/g, `stroke="${color}"`)
    .replace(/fill="black"/g, `fill="${color}"`)
    .replace(/stroke="#000"/g, `stroke="${color}"`)
    .replace(/fill="#000"/g, `fill="${color}"`);
}
